import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnChanges, ViewChild } from '@angular/core';
import { ModalDirective } from 'angular-bootstrap-md';

@Component({
  selector: 'error-component',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss'],
})
export class ErrorComponent implements OnChanges {
  @ViewChild('errorModal', { static: true }) errorModal: ModalDirective;

  @Input() error: HttpErrorResponse;
  @Input() showModal: boolean = false;

  title: string = 'Error Report';

  apiMessage: string;
  apiDetails: string;
  apiCode: string;
  apiStatusCode: string;
  showApiErrorCard: boolean = false;

  httpMessage: string;
  httpStatus: number;
  httpDetails: string;
  showHttpErrorCard: boolean = false;

  url: string;
  busy: boolean = false;

  constructor() {}

  ngOnChanges(): void {
    if (!this.error) {
      return;
    }
    this.handleError(this.error);
    this.showHideModal(!!this.error);
    this.showApiErrorCard = !!this.apiCode || !!this.apiMessage || !!this.apiDetails;
    this.showHttpErrorCard = !!this.httpStatus || !!this.httpMessage || !!this.httpDetails;
  }

  showHideModal(toggle: boolean) {
    if (toggle != null) {
      this.showModal = toggle;
    }
    if (this.showModal) {
      this.errorModal.show();
    } else if (!this.showModal) {
      this.error = null;
      this.errorModal.hide();
    }
  }

  private handleError(errorObject: HttpErrorResponse) {
    if (errorObject) {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong.
      if (errorObject.error) {
        this.apiCode = errorObject.error.ErrorCode;
        this.apiMessage = errorObject.error.ErrorMessage;
        this.apiDetails = errorObject.error.title ?? errorObject.error.ErrorDetail;
        this.apiStatusCode = errorObject.error.StatusCode;
        //fallback error in case the error object does not match above
        if (!this.apiMessage) {
          this.apiMessage = errorObject.message;
          this.apiStatusCode = `${errorObject.status.toString()} - ${errorObject.statusText}`;
          this.apiDetails = errorObject.error?.title ?? errorObject.error;
        }
      } else {
        // A client-side or network error occurred. Handle it accordingly.
        this.httpDetails = errorObject.error;
        this.httpStatus = errorObject.status;
        this.httpMessage = errorObject.message;
      }
      this.url = errorObject.url;
    }
  }
}
